module.exports = __webpack_public_path__ + "img/eye.c7da733b.svg";